type UseResendCooldownReturn = {
    resendCooldown: Ref<number>;
    isResendDisabled: Ref<boolean>;
    startResendCooldown: () => void;
    resetResendCooldown: () => void;
};

const DEFAULT_DURATION_SECONDS = 60;

export const useResendCooldown = (durationSeconds: number = DEFAULT_DURATION_SECONDS): UseResendCooldownReturn => {
    const resendCooldown = ref(0);
    const isResendDisabled = computed(() => resendCooldown.value > 0);
    let resendTimer: ReturnType<typeof setInterval> | undefined = undefined;

    const clearResendTimer = (): void => {
        if (resendTimer) {
            clearInterval(resendTimer);
            resendTimer = undefined;
        }
    };

    const startResendCooldown = (): void => {
        clearResendTimer();

        resendCooldown.value = durationSeconds;
        resendTimer = setInterval(() => {
            resendCooldown.value--;

            if (resendCooldown.value <= 0) {
                clearResendTimer();
            }
        }, 1000);
    };

    const resetResendCooldown = (): void => {
        clearResendTimer();
        resendCooldown.value = 0;
    };

    onUnmounted(() => {
        clearResendTimer();
    });

    return { resendCooldown, isResendDisabled, startResendCooldown, resetResendCooldown };
};
